import { PlusCircle } from "lucide-react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "@/design-system/native";
import { useMemo, useState } from "react";
import { toast } from "react-toastify";
import { useQuickAdd } from "../../../_helper/QuickAdd/QuickAddProvider";
import styles from "./AddBtnHeader.module.scss";

const AddBtnHeader = () => {
  const { actions } = useQuickAdd();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const menuItems = useMemo(
    () => [
      { key: "addTask", label: "Add task", handler: actions?.addTask },
      {
        key: "addMultipleTasks",
        label: "Add multiple tasks",
        handler: actions?.addMultipleTasks,
      },
      {
        key: "addProjectTime",
        label: "Add project time",
        handler: actions?.addProjectTime,
      },
      { key: "addEvent", label: "Add event", handler: actions?.addEvent },
      { key: "addNote", label: "Add note", handler: actions?.addNote },
      { key: "addTodo", label: "Add to do", handler: actions?.addTodo },
      { key: "addTicket", label: "Add ticket", handler: actions?.addTicket },
    ],
    [actions]
  );

  const handleSelect = (item) => () => {
    if (typeof item.handler === "function") {
      item.handler();
    } else {
      toast.info(`\"${item.label}\" bu sayfada kullanılamıyor.`);
    }
    setDropdownOpen(false);
  };

  return (
    <li>
      <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down" inNavbar>
        <DropdownToggle
          tag="span"
          data-toggle="dropdown"
          aria-expanded={dropdownOpen}
          className={styles.toggle}
          size="20"
        >
          <PlusCircle className="header-icon" />
        </DropdownToggle>

        <DropdownMenu end>
          {menuItems.map((item) => {
            const enabled = !!item.handler;
            return (
              <DropdownItem
                key={item.key}
                onClick={handleSelect(item)}
                className={styles.menuItem}
                style={{
                  "--item-cursor": enabled ? "pointer" : "not-allowed",
                  "--item-opacity": enabled ? 1 : 0.5,
                }}
              >
                {item.label}
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </li>
  );
};

export default AddBtnHeader;
